export default function IconDraggable({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM8 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM16 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM16 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
    </svg>
  );
}
